import React, { useEffect, useMemo, useState } from "react";
import { concat, every, flattenDeep, get, some } from "lodash";
import Button from "../../../components/CustomButtons/Button";
import { alphabet, clone, currencyToNumber, formatDollar, get2DecimalRound, handleError, parseFloatString } from "../../../shared/utility";
import PaymentSchedule from "./PaymentSchedule";
import { IconButton } from "@material-ui/core";
import axios from "store/axios/axios-invoice";
import { useRef } from "react";
import {
    calculateAbatedRanges,
    calculateAdjustedCommission,
    calculateEstimatedAbatedRanges,
    calculateEstimatedTermsTotal,
    getFlatFeeCommission,
    isEstimatedLease,
    isFlatFeeCommissionEnabled,
    newYearlyCalculation,
    typeDescriptionsDict,
} from "../RSheetsLogic";
import { getUser } from "../../../shared/authValidation";
import InvoicePaymentLines from "./InvoicePaymentLines";
import NotificationAsk from "../../../components/Notification/NotificationAsk";
import { getTotalInvoicePayment, getTotalInvoicePaymentWithoutLineItems } from "../../Invoices/InvoiceLogic";
import moment from "moment";
import { commissionCalc } from "./CommissionLogic";
import termLogic from "./Term/TermLogicMain";

const InvoicePayment = (props) => {
    const { updateDataObj, field, data, commissionValue = undefined,
        the_invoices,
        set_the_invoices
     } = props;
    const [scrollRef, setScrollRef] = useState(null);
    const [openedAskDelete, setOpenedAskDelete] = useState(-1);
    const [invoicesData, setInvoicesData] = useState({}); // status
    const ref = useRef(null);

    const payments = data.invoices ? data.invoices : [];
    const lease_term = get(data, "lease_term", []);
    const abated_rent_ranges = get(data, "abated_rent_ranges", []);
    const isEstimated = isEstimatedLease(data);

    const flatFeeEnabled = isFlatFeeCommissionEnabled(data) 
        || commissionValue 
        || props.sheetType === 'Consulting'
        || props.sheetType === 'LeaseAssignmentFee';
    const flatFeeCommission = currencyToNumber(commissionValue) || getFlatFeeCommission(data);
    console.log('flatFeeCommission', flatFeeCommission)
	const isActualDays = get(data, "commission_based_off", "") === "Actual Days";

    // Range calculation happens everywhere, so minimize the calculation as much as possible
    const total = useMemo(() => {
        console.log('flat fee enabled', flatFeeEnabled, props, calculateAdjustedCommission(data))
        if (flatFeeEnabled) {
            if (props.sheetType === 'Sale') {
                return parseFloatString(data.sale_sale_commission) + calculateAdjustedCommission(data);
            } else {
                return flatFeeCommission + calculateAdjustedCommission(data);
            }
        } else {
            const calc = termLogic.calculateLeaseTerm(data);
            const grossCommission = calc.gross_total_commission;
            const abatedCommission = calc.gross_abated_commission;
            console.log('NEP gross calc', grossCommission, calc);
            console.log('NEP abated calc', abatedCommission);
            return grossCommission - abatedCommission + calculateAdjustedCommission(data);
        }
    }, [lease_term, abated_rent_ranges, flatFeeEnabled, flatFeeCommission]);

    const getInvoices = async () => {
        try {
            const response = await axios.get(`/entries?rs_id=${data.id}`);
            const rdata = response.data;
            console.log('invoice data', rdata);
            const newObj = {};
            rdata.forEach(rd => {
                newObj[rd.id] = {
                    status: rd.status,
                    dat: rd,
                    invoice_num: rd.invoice_num
                }
            })
            setInvoicesData(newObj);
            //
            set_the_invoices(rdata);
        } catch(e) {
            handleError(e);
        }
    }

    // Scroll
    useEffect(() => {
        if (scrollRef) {
            handleScrollClick();
            setScrollRef(null);
        }
    }, [scrollRef]);

    useEffect(() => {
        // load invoices by RS ID 

        if (data.id) {
            getInvoices();
        }
    }, []);

    const handleScrollClick = () => {
        ref.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        });
    };

    const canRender = true; //payments.length === 0 || (payments.length > 0 && Array.isArray(payments[0]));

    const canAddLineEntries = getUser("Invoice enter_line_items");

    console.log('user->', canAddLineEntries);

    const renderPayments = () => {
        const main_invoice_id = '1000';
        if (!the_invoices) return null;
        const paymentsSection = <div>
            {the_invoices.map((pm, index) => {
                console.log('the_invoices', pm)
                const alphabet_ = alphabet[index];
                const invoice_id = pm.id;
                let invoice_num = `${alphabet_}`;
                if (invoicesData.hasOwnProperty(invoice_id)) {
                    if (invoicesData[invoice_id].invoice_id) {
                        invoice_num = invoicesData[invoice_id].invoice_id;
                    }
                }
                let invoice_num_shouldnt_real = false;
                if (props.praps) {
                    if (props.praps.rsheetData) {
                        if (props.praps.rsheetData.status !== 9) {
                            invoice_num_shouldnt_real = true;
                        }
                    }
                }
                if (pm.invoice_num && !invoice_num_shouldnt_real) {
                    invoice_num = pm.invoice_num;
                }
                console.log('praps2', props);
                return (
                    <div className="boxed" key={index} ref={scrollRef === index ? ref : null}>
                        <div style={{ float: "right" }}>
                            <IconButton onClick={() => setOpenedAskDelete(index)}>
                                <i className="fas fa-trash-alt red-text"></i>
                            </IconButton>
                        </div>
                        <h4 className="red-text bold">Invoice # {invoice_num}</h4>
                        <PaymentSchedule
                            data={data}
                            field={field}
                            handleAddNewPayment={handleAddNewPayment(index)}
                            handleUpdatePayment={handleUpdatePayment(index)}
                            handleDeletePayment={(pm_index) => {
                                console.log('ddeleting', index, pm_index);
                                handleDeletePayment(index, pm_index);
                            }}
                            handleDeletePaymentEntry={handleDeletePaymentEntry(index)}
                            iv_index={index}
                            payments={pm.data?.entries ? pm.data?.entries : []}
                            invoiceList={pm.data?.entries ? pm.data?.entries : []}
                            totalPayment={totalPayment}
                            total={total}
                            updateDataObj={updateDataObj}
                            invoicesData={invoicesData}
                            sheetType={props.sheetType}
                            pm_entry={pm}
                            the_invoices={props.the_invoices}
                        />
                        {canAddLineEntries && <InvoicePaymentLines 
                            updateDataObj={updateDataObj}
                            data={data}
                            invoice_index={index}
                            the_invoices={the_invoices}
                            set_the_invoices={set_the_invoices}
                            handleDeleteLineItem={handleDeleteLineItem(index)}
                            handleUpdateLineItem={handleUpdateLineItem(index)}
                            handleAddLineItem={handleAddLineItem(index)}
                        />}
                    </div>
                );
            })}

            {openedAskDelete !== -1 && <NotificationAsk 
                title="Are you sure?"
                message="Do you want to delete this invoice?"
                open={true}
                close={() => {
                    setOpenedAskDelete(-1);
                }}
                success={async () => {
                    const invoiceToBeDeleted = the_invoices[openedAskDelete];
                    console.log('invoice to be deleted', invoiceToBeDeleted)
                    if (invoiceToBeDeleted.id) {
                        console.log('deleting', invoiceToBeDeleted.id);
                        try {
                            await axios.delete('/entry?id='+invoiceToBeDeleted.id+'&actual=true');
                            getInvoices();
                        } catch(e) {
                            handleError(e);
                            alert('Could not delete invoice');
                            return;
                        }
                    }
                    setOpenedAskDelete(-1);
                }}
            />}
        </div>
        return paymentsSection;
    };

    // ADDS INVOICE
    const handleAddNewPayment = (iv_index) => async (pm) => {
        console.log('iv_ind', iv_index, pm);
        try {
            const invoice = the_invoices[iv_index];
            if (invoice) {
                if (!invoice.data.entries) {
                    invoice.data.entries = [];
                }
                invoice.data.entries.push(pm)
            }
            await axios.put('/entry', invoice);
            getInvoices();
        } catch(e) {
            handleError(e);
        }
    };

    // ADDS INVOICE LINE ITEM
    const handleAddLineItem = (iv_index) => async (pm) => {
        console.log('iv_ind', iv_index, pm);
        try {
            const invoice = the_invoices[iv_index];
            if (invoice) {
                if (!invoice.data.line_items) {
                    invoice.data.line_items = [];
                }
                invoice.data.line_items.push(pm)
            }
            await axios.put('/entry', invoice);
            getInvoices();
        } catch(e) {
            handleError(e);
        }
    };

    // UPDATES INVOICE ENTRIES
    const handleUpdatePayment = (iv_index) => async (pm_index, newPm) => {
        try {
            const invoice = the_invoices[iv_index];
            if (invoice) {
                invoice.data.entries[pm_index] = newPm;
            }
            await axios.put('/entry', invoice);
            getInvoices();
        } catch(e) {
            handleError(e);
        }
    };

    // UPDATES INVOICE LINE ITEM
    const handleUpdateLineItem = (iv_index) => async (pm_index, newPm) => {
        try {
            const invoice = the_invoices[iv_index];
            if (invoice) {
                invoice.data.line_items[pm_index] = newPm;
            }
            await axios.put('/entry', invoice);
            getInvoices();
        } catch(e) {
            handleError(e);
        }
    };

    // UPDATES INVOICE BY DELETING PAYMENT ENTRY
    const handleDeletePaymentEntry = (iv_index) => async (pm_index) => {
        try {
            const invoice = the_invoices[iv_index];
            if (invoice) {
                invoice.data.entries = invoice.data.entries.filter((de,i) => {
                    if (i === pm_index) return false;
                    return true;
                });
            }
            await axios.put('/entry', invoice);
            getInvoices();
        } catch(e) {
            handleError(e);
        }
    };

    const handleDeleteLineItem = (iv_index) => async (line_index) => {
        try {
            const invoice = the_invoices[iv_index];
            if (invoice) {
                invoice.data.line_items = invoice.data.line_items.filter((de,i) => {
                    if (i === line_index) return false;
                    return true;
                });
            }
            await axios.put('/entry', invoice);
            getInvoices();
        } catch(e) {
            handleError(e);
        }
    };

    // DELETES INVOICE
    const handleDeletePayment = async (iv_index, pm_index) => {
        console.log('deleting', iv_index, pm_index)
        if (typeof iv_index === 'number') {
            try {
                const invoice = the_invoices[iv_index];
                await axios.delete("/entry?id=" + invoice.id);
                getInvoices();
            } catch(e) {
                handleError(e);
            }
        }
    };

    const handleAddInvoice = async () => {
        // Add new real invoice 
        const newData = clone(data);
        const newInvoice = {
            rs_id: data.id,
            title: "Generated from RS illi# " + data.illi_number,
            data: {
                entries: [],
                line_items: []
            }
        }
        try {
            const postObj = {
                status: 1, // PENDING
                data: {
                    rsData: data,
                    invoice_index: "", // used to calculate befores
                    attn: '',
                    date: moment().format('MM/DD/YYYY'),
                    illi: get(data, "illi_number", ""),
                    sqft: "",
                    agent: "",
                    buyer: "",
                    rs_id: newInvoice.rs_id,
                    terms: "",
                    title: newInvoice.title,
                    seller: "",
                    balance: "",
                    bill_to: "",
                    invoice: "",
                    project: "",
                    total_rate: "",
                    total_month: "",
                    leasing_term: "",
                    total_amount: "",
                    consideration: "",
                    property_address: "",
                    total_commission: "",
                    total_annual_rent: "",

                    entries: [],
                    line_items: []
                }
            };
            console.log('post', postObj)
            const result = await axios.post('/entry', postObj);
            const insertId = result.data.insertId ? result.data.insertId : null;
            if (!insertId) throw "No ID";
            newInvoice.id = insertId;
            await getInvoices();
            setTimeout(() => {
                if (the_invoices.length > 0) {
                    setScrollRef(the_invoices.length - 1);
                }
            }, 1000);
        } catch(e) {
            handleError(e);
            alert('Could not create invoice');
        }
        
    };

    // Calculate total payments from ALL invoices
    const newData = clone(data) 
    newData.invoices = the_invoices;
    const totalPayment = getTotalInvoicePaymentWithoutLineItems(newData, props.sheetType ? typeDescriptionsDict[props.sheetType] : null);
    console.log('total=>', total, totalPayment);
	const commissionRemaining = formatDollar(parseFloat(get2DecimalRound(total) - get2DecimalRound(totalPayment)));
	const commissionRemainingClass = commissionRemaining == '$0.00' ? 'green' : 'red'

    console.log('InvoicePayment', props, payments, canRender);

    return (
        <div className={!props.canEditInvoiceRelatedData ? 'gray-bg-input avoid-clicks' : ''}>
            <div style={{display: 'flex', alignItems: 'canter'}}>
                <Button disabled={totalPayment >= total} color="primary" onClick={handleAddInvoice}>
                    <i className="fas fa-plus"></i> ADD INVOICE
                </Button>

                <div style={{marginLeft: '20px'}}>
                    <div className='black'>Total Commission: {formatDollar(total)}</div>
					<div className={commissionRemainingClass}>Total Commission Remaining to bill: {commissionRemaining}</div>
                </div>
            </div>

            {canRender && (
                <div style={{ padding: 20 }}>
                    {renderPayments()}
                </div>
            )}
        </div>
    );
};

export default InvoicePayment;
